<template>
  <div>
    <el-dialog :title="title" width="30%" :visible.sync="dialogFormVisible" label-position="top" :close-on-click-modal="false" :before-close="beforeClose">
      <el-form :model="form" :rules="rules" ref="form" :show-message="false" status-icon>
        <el-form-item label="Reward type" prop="type">
          <el-select v-model="form.type" placeholder="Please select reward type" @change="typeChange">
            <el-option
                v-for="(item, index) in typesArray"
                :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Reward name" prop="name" v-if="form.type === '1'">
          <el-input v-model="form.name" type="text" placeholder="Input reward name"></el-input>
        </el-form-item>
        <el-form-item label="Reward name" prop="coupon_id" v-if="form.type === '2'" >
          <el-select v-model="form.coupon_id" placeholder="Please select reward name" @change="changeHandle">
            <el-option v-for="item in couponList" :key="item.coupon_id" :label="item.coupon_name" :value="item.coupon_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Coupons rate" prop="rate" v-if="form.type === '2'" required>
          <el-select v-model="form.rate" placeholder="Please select coupon rate" disabled>
<!--            coupon_type-->
            <el-option v-for="item in couponList" :key="item.coupon_no" :label="item.coupon_rate" :value="item.coupon_rate"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Points needed" prop="points">
          <el-input v-model="form.points" @input="pointInputHandle" placeholder="Input a point between 1 ~ 100000"></el-input>
        </el-form-item>
        <el-form-item label="Upload a reward picture (4:3)" required>
          <ra-img-upload class="mt-12"  :uploadApiPath="'/adminapi/rewordUpload'" :width="222" :height="166" v-model="form.image"></ra-img-upload>
        </el-form-item>
        <el-form-item label="Term of use" prop="term_of_use">
          <el-input v-model="form.term_of_use" type="textarea" :rows="3" :disabled="form.type === '2'" resize="none" placeholder="Input term of use"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" plain class="w-[80px] changeFocus p-0 border-black text-black">Cancel</el-button>
        <el-button type="success" @click="submitHandler" class="w-[80px] p-0">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RaImgUpload from "@/components/ra-img-upload.vue";
import {createRedemption, editRedemption, getCouponList} from "@/api/redemption";
import { getCouponDetail } from "@/api/coupon";

export default {
  name: "create-and-edit",
  components: {RaImgUpload},
  props: {
    editRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      rules: {
        type: [
          { required: true, message: 'Please select a reward type' },
        ],
        name: [
          { required: true, message: 'Input reward name' },
        ],
        coupon_id: [
          { required: true, message: 'Select coupon rate' },
        ],
        points: [
          { required: true, message: 'Input a point between 1 ~ 100000' },
          {
            validator: this.validatePoints,
            trigger: 'blur'
          }
        ],
      },
      title: 'Create a reward',
      dialogFormVisible: true,
      typesArray: [
        { label: "Digital cards", value: "1" },
        { label: "Coupons", value: "2" }
      ],
      couponList: [
      ],
      form: {
        type: '1',
        name: '',
        points: '',
        rate: '',
        coupon_id: '',
        image: '',
        term_of_use: '',
      }
    }
  },
  mounted() {
    if (this.editRow?.id) {
      this.title = 'Edit a reward';
      this.initData()
    }
    getCouponList().then(res=> {
      if (res.code === 200) {
        this.couponList = res.data.list;
      } else {
        this.$message.error(res.msg);
      }
    })
  },
  methods: {
    validatePoints(rule, value, callback) {
      const points = parseInt(value, 10);
      console.log(points,'dd')
      if ( points < 1 || points > 100000) {
        this.$message({
          type: "warning",
          message: 'Please input a point between 1 and 100000.'
        });
        callback(new Error());
      } else {
        callback(); // 验证通过
      }
    },
    pointInputHandle(value){
      this.form.points = value.replace(/\D/g, '');
    },
    initData() {
      console.log(this.editRow,'ddd')
      this.form.id = this.editRow.id;
      this.form.type = this.editRow.type.toString();
      this.form.name = this.editRow.reward_name;
      this.form.term_of_use = this.editRow.term_of_use;
      this.form.points = this.editRow.points_needed;
      this.form.image = this.editRow.picture;
      this.form.coupon_id = this.editRow.type.toString() === '2' ? this.editRow.coupon_info?.coupon_id : '';
      if  (this.editRow.type.toString() === '2'){
        if (this.editRow.coupon_info.coupon_type == 1){
          this.form.rate = '$' + this.editRow.coupon_info?.coupon_rate
        }else{
          this.form.rate = Number(this.editRow.coupon_info?.coupon_rate) + '% off'
        }
        this.getCouponDetailInfo(this.form)
      }
      // this.form.rate = this.editRow.type.toString() === '2' ? this.editRow.coupon_info?.coupon_rate : ''
    },
    close() {
      this.$emit('closeEditor');
    },
    getCouponDetailInfo(item) {
      getCouponDetail({ coupon_id: item.coupon_id }).then(res=> {
        if (res.code === 200) {
          this.form.term_of_use = res.data.term_of_use;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    changeHandle(val) {
      const item = this.couponList.find(item => item.coupon_id === val)
      this.form.name = item?.coupon_name;
      if  (item.coupon_type == 2){
        this.form.rate = item?.coupon_rate +'%' + ' ' + 'off';
      }else{
        this.form.rate = '$'+ item?.coupon_rate;
      }
      this.getCouponDetailInfo(item)
    },
    typeChange(val) {
      if (val === '1'){
        this.form.name = '';
        this.form.coupon_id = '';
      }
    },
    beforeClose(done) {
      this.close();
      done()
    },
    submitHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.editRow?.id) {
            editRedemption(this.form).then(res =>{
              if (res.code === 200) {
                this.$message.success('update success');
                this.$emit('updateList');
                this.close()
              } else {
                this.$message.error(res.msg);
              }
            })
          } else {
            this.form.id =''
            createRedemption(this.form).then(res => {
              if (res.code === 200) {
                this.$message.success('create success');
                this.$emit('updateList');
                this.close()
              } else {
                this.$message.error(res.msg);
              }
            })
          }
        }else{
          this.$message({
            type:"warning",
            message:'Some information missing'
          })
        }
      })
    }
  }
}
</script>
